module.exports = __webpack_public_path__ + "img/face-tired.18174ce6.svg";